/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApp } from 'vue'

import App from './App.vue'

// Wait for ready element by WP elementor
;(window as any).proximilarInitSearchCompanyForecast = () => {
    const mountEls = document.getElementsByClassName('search-company-forecast')
    for (let i = 0; i < mountEls.length; i++) {
        const mountEl = mountEls[i]
        const dataset = (mountEl as HTMLElement)?.dataset || {}

        createApp(App, { ...dataset }).mount(mountEl)
    }
}
;(window as any).proximilarInitSearchCompanyForecast()
